import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ButtonLoader = ({ 
  isLoading, 
  children, 
  className = "",
  disabled = false,
  onClick
}) => {
  return (
    <motion.button
      whileHover={!disabled && !isLoading ? { scale: 1.03 } : {}}
      whileTap={!disabled && !isLoading ? { scale: 0.98 } : {}}
      onClick={onClick}
      disabled={disabled || isLoading}
      className={`
        btn-primary
        relative
        overflow-hidden
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
        ${className}
      `}
      style={{
        transition: 'all 300ms cubic-bezier(0.22, 0.61, 0.36, 1)'
      }}
    >
      {/* Loading Spinner */}
      <AnimatePresence>
        {isLoading && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            className="absolute inset-0 flex items-center justify-center"
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{
                duration: 1,
                repeat: Infinity,
                ease: "linear"
              }}
              className="w-5 h-5 border-2 border-current border-t-transparent rounded-full"
            />
          </motion.div>
        )}
      </AnimatePresence>

      {/* Button Content */}
      <motion.div
        animate={{ 
          opacity: isLoading ? 0 : 1,
          scale: isLoading ? 0.9 : 1
        }}
        transition={{ duration: 0.2 }}
        className="flex items-center justify-center"
      >
        {children}
      </motion.div>
    </motion.button>
  );
};

export default ButtonLoader;



